import React from "react";

function Footer() {
  return (
    <footer className="tc-footer-style1" id="footer-tetra">
      <div className="container">
        <div className="top-content section-padding">
          <div className="row gx-0">
            <div className="col-lg-3">
              <div className="info-side">
                <div className="text fsz-24 color-333 lh-3 fw-600">
                  Tetra Yapı, mimarinin yaşamı dönüştürdüğüne inanır;
                  projelerini yenilik, sürdürülebilirlik ve estetik üzerine
                  kurar.
                </div>
                <div className="foot-social mt-50">
                  <a href="#">
                    <i className="fab fa-x-twitter"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-2 offset-lg-1">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> İletişim </h5>
                <p>
                  Kardelen Apt, Sarıgüllük, 61035 Nolu Sk No:22/A Altı, 27060
                  Şehitkamil/Gaziantep
                </p>
                <p><strong>Tel :</strong> +90 533 301 36 05</p>
              </div>
            </div>
            <div className="col-lg-2 offset-lg-1">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600">Projeler</h5>
                <ul className="footer-links">
                  <li>
                    <a href="/projects/yamactepe">Moda Yamaçtepe</a>
                  </li>
                  <li>
                    <a href="/projects/aktoprak">Villa Moda Aktoprak</a>
                  </li>
                  <li>
                    <a href="#"> Sürdürülebilir Mimari Tasarım </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 offset-lg-1">
              <div className="branch-card">
                <h5 className="mb-20 mt-5 fw-600"> Yardım </h5>
                <ul className="footer-links">
                  <li>
                    <a href="#"> Tetra Kariyer </a>
                  </li>
                  <li>
                    <a href="#"> Partner Policy </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row">
            <div className="col-lg-12 text-center">
              <p className="fsz-13">
                © 2025 designed and developed by{" "}
                <a href="https://hook.software">Hook Software Studio</a>. All
                Right Reserved for Tetra Yapı.
              </p>
            </div>
            {/*  <div className="col-lg-6">
              <div className="foot-links mt-4 mt-lg-0">
                <a href="#"> Home </a>
                <a href="#"> Studio </a>
                <a href="#"> Cases </a>
                <a href="#"> News </a>
                <a href="#"> Contact </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
